import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ServiceDetail from './pages/ServiceDetail';
import LoginPage from './pages/LoginPage';
import ContactListPage from './pages/ContactListPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/contacts" element={<ContactListPage />} />
          <Route path="/admin/change-password" element={<ChangePasswordPage />} />
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
